export default __webpack_public_path__ + "static/media/18_1.af807b87.jpg";